import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'intervalHHMM' })
export class IntervalHHMMPipe implements PipeTransform {
  transform(ms: number): string {
    if (!ms || ms <= 0) return '0h 0m';

    const totalMinutes = Math.floor(ms / (1000 * 60));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return `${hours}h ${minutes}m`;
  }
}
